// extracted by mini-css-extract-plugin
module.exports = {"compWrap":"UiInput_compWrap__2Saye","label":"UiInput_label__lgqle","input":"UiInput_input__2eDsY","hide":"UiInput_hide__1uMaj"};